import type { ReactNode } from 'react';

/**
 * Label + control wrapper with the standard vertical rhythm (gap-1.5) used
 * across forms. Renders as a <label> so the wrapped control is implicitly
 * associated. Optional hint/error slot below keeps error text near its field.
 */
export function Field({
  label,
  hint,
  error,
  required,
  className = '',
  children,
}: {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label className={`flex flex-col gap-1.5 ${className}`.trim()}>
      <span className="text-sm-label font-semibold text-ink-2">
        {label}
        {required ? <span className="text-primary"> *</span> : null}
      </span>
      {children}
      {error ? (
        <span className="text-sm-label text-danger">{error}</span>
      ) : hint ? (
        <span className="text-sm-label text-ink-3">{hint}</span>
      ) : null}
    </label>
  );
}
